export const mdsColorsValue = {
  grey: {
    x0: "#FFFFFF",
    x25: "#F8F8FA",
    x50: "#F3F3F5",
    x100: "#E8E9ED",
    x200: "#D3D5DA",
    x300: "#CACCD3",
    x400: "#9397A5",
    x500: "#696E7D",
    x600: "#3F424D",
    x700: "#323640",
    x800: "#1A1C23",
    x875: "#111827",
    x900: "#111318",
  },
  primary: {
    x25: "#FFFCFD",
    x50: "#FFCEDF",
    x100: "#FBBECE",
    x200: "#F7809F",
    x300: "#F55780",
    x400: "#F04773",
    x500: "#F22E61",
    x600: "#CF2652",
    x700: "#AB1D42",
    x800: "#76112B",
    x900: "#53081C",
  },
  secondary: {
    x100: "#EDF2FF",
    x200: "#9DB6FA",
    x300: "#6B8FF2",
    x400: "#3B6DF1",
    x500: "#3360D6",
    x600: "#234191",
    x700: "#152759",
  },
  green: {
    x400: "#09A57F",
    x500: "#10B981",
    x700: "#6BC9B2",
  },
  blue: {
    x100: "#EDF2FF",
    x200: "#9DB6FA",
    x300: "#6B8FF2",
    x400: "#3B6DF1",
    x500: "#3360D6",
    x600: "#234191",
    x700: "#152759",
  },
  blueprint: {
    0: "#F6F8FF",
    100: "#E6EDFF",
    200: "#A6BFFF",
    300: "#6792FF",
    400: "#3D69D9",
    500: "#1D47B3",
  },
  mblue: {
    x50: "#F0F4FF",
    x100: "#DCE6FE",
    x200: "#BECFFE",
    x300: "#91AEFD",
    x400: "#618BFA",
    x500: "#3C6FF6",
    x600: "#2458EB",
    x700: "#1D4FD7",
    x800: "#1E44AE",
    x900: "#1E3B8A",
  },
  red: {
    x50: "#FEF2F2",
    x100: "#FEE2E2",
    x200: "#FECACA",
    x300: "#FCA5A5",
    x400: "#F87171",
    x500: "#EF4444",
    x600: "#DC2626",
    x700: "#B91C1C",
    x800: "#991B1B",
    x900: "#7F1D1D",
  },
  lilac: {
    x50: "#F5EDF9",
    x100: "#F3E9F8",
    x200: "#ECE0F2",
    x300: "#AB5BD2",
    x400: "#AA52D6",
    x500: "#903EB8",
  },
  white: "#FFF",
  selectedBackground: "#F5F8FF",
  transparent: "transparent",
  chat: {
    header: "#6B7280",
  },

  // Semantic Variables - Setting everything to yellow first
  text: {
    contrast: "#FFFF00",
    primary: "#FFFF00",
    secondary: "#FFFF00",
    tertiary: "#FFFF00",
    onAccent: "#FFFF00",
    link: {
      default: "#FFFF00",
      hover: "#FFFF00",
    },
    emphasis: "#FFFF00",
    positive: "#FFFF00",
    negative: "#FFFF00",
    danger: "#FF0000",
    editor: {
      metadata: "#FF0000",
    },
  },
  editor: {
    0: "#FF0000",
    100: "#FF0000",
    200: "#FF0000",
    300: "#FF0000",
    400: "#FF0000",
    500: "#FF0000",
  },
  icon: {
    primary: "#FFFF00",
    secondary: "#FFFF00",
    placeholder: "#FFFF00",
    onAccent: "#FFFF00",
    brand: "#FFFF00",
    selected: "#FFFF00",
    emphasis: "#FFFF00",
    danger: "#FFFF00",
    onChromeInactive: "#FFFF00",
  },
  surface: {
    chrome: "#FFFF00",
    pane: "#FFFF00",
    paneHeader: "#FFFF00",
    headsUp: {
      default: "#FFFF00",
      hover: "#FFFF00",
    },
    chat: "#FFFF00",
    menu: "#FFFF00",
    modal: "#FFFF00",
    popover: "#FFFF00",
    toast: "#FFFF00",
    preview: "#FFFF00",
    previewHeader: "#FFFF00",
    tooltip: "#FFFF00",
    overlay: {
      default: "#FFFF00",
      onboarding: "#FFFF00",
    },
    onboarding: "#FFFF00",
    onboardingSubtle: "#FFFF00",
  },
  border: {
    input: {
      default: {
        default: "#FFFF00",
        focused: "#FFFF00",
        danger: "#FF0000",
      },
      brand: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      emphasis: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
    },
    button: {
      marketing: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
    },
    default: "#FFFF00",
    hover: "#FFFF00",
    surface: "#FFFF00",
    onAccent: "#FFFF00",
    chrome: "#FFFF00",
    emphasis: "#FFFF00",
    ghost: "#FFFF00",
  },
  background: {
    voice: {
      self: "#FF00FF",
      others: "#FFFF00",
    },
    button: {
      contrast: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      default: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      chip: {
        default: "#FFFF00",
        hover: "#FFFF00",
        selectedNegative: "#FFFF00",
        selectedPositive: "#FFFF00",
      },
      toggle: {
        default: "#FFFF00",
        hover: "#FFFF00",
        toggled: "#FFFF00",
        toggledHover: "#FFFF00",
      },
      onAccent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      emphasis: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      emphasisLight: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      transparent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      navigation: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      chrome: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      subtle: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      danger: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      dangerFilled: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      brand: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      tabBar: {
        active: "#FFFF00",
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      onChrome: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      floatingIcon: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      contrastAccent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
    },
    list: {
      default: "#FFFF00",
      hover: "#FFFF00",
      selected: "#FFFF00",
      deepsearch: "#FFFF00",
    },
    menu: {
      default: "#FFFF00",
      hover: "#FFFF00",
      selected: "#FFFF00",
      emphasized: "#FFFF00",
    },
    input: {
      default: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      chrome: {
        default: "#FFFF00",
        focused: "#FFFF00",
        hover: "#FFFF00",
      },
      onAccent: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      inline: {
        default: "#FFFF00",
        hover: "#FFFF00",
        focused: "#FFFF00",
      },
    },
    message: {
      user: "#FFFF00",
      mem: "#FFFF00",
    },
    badge: {
      default: "#FFFF00",
      emphasis: "#FFFF00",
      moreEmphasis: "#FFFF00",
      negative: "#FFFF00",
    },
    banner: {
      danger: "#FFFF00",
      emphasis: "#FFFF00",
      default: "#FFFF00",
    },
    card: {
      emphasis: "#FFFF00",
      default: "#FFFF00",
    },
    activeTab: "#FFFF00",
    illustration: {
      default: "#FFFF00",
      onAccent: "#FFFF00",
      contrast: "#FFFF00",
    },
    diff: "#FFFF00",
    skeleton: {
      bg: "#FFFF00",
      ends: "#FFFF00",
      middle: "#FFFF00",
    },
  },
  success: "#FF0000",
};

export type MDSColors = typeof mdsColorsValue;

// This is the function version for backward compatibility
export const mdsColors = () => mdsColorsValue;
